module.exports = __webpack_public_path__ + "media/images/home/proof_of_income@2x-fe263c697fc04ca3fc52eb405fc0a637.png";